import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { SwiperOptions } from 'swiper';
import { FeaturedTestimony } from '../../models/entities/testimony/featured-testimony.entity';
import { SwiperConfig } from '../../utils/swiper-config';
import { HttpFeaturedTestimonyService } from '../../../core/services/http/http-featured-testimony.service';
import { FeaturedTestimonyQueryData } from '../../models/payloads/testimony/featured-testimony.payload';
import { FeaturedTestimonyPublicationStatus } from '../../models/enums/publication-status.enums';

@Component({
  selector: 'app-landing-testimonies',
  templateUrl: './landing-testimonies.component.html',
  styleUrls: ['./landing-testimonies.component.scss'],
})
export class LandingTestimoniesComponent implements OnInit {
  @Input() onLanding = false;

  landingTestimoniesSwiperConfig: SwiperOptions;
  landingTestimonies: FeaturedTestimony[];

  constructor(
    public languageService: LanguageService,
    private httpFeaturedTestimonyService: HttpFeaturedTestimonyService
  ) {}

  ngOnInit(): void {
    this.initSwiperConfigs();
  }

  getFeaturedTestimonies() {
    this.httpFeaturedTestimonyService
      .list(
        new FeaturedTestimonyQueryData({
          publicationStatus: [FeaturedTestimonyPublicationStatus.PUBLISHED_ON_LANDING],
        })
      )
      .subscribe((res) => {
        this.landingTestimonies = res['hydra:member'].map((elt) => new FeaturedTestimony(elt));
      });
  }

  initSwiperConfigs() {
    this.landingTestimoniesSwiperConfig = new SwiperConfig(
      'landingTestimonies',
      50,
      true,
      false,
      1,
      5000
    ).config;
  }
}
